import * as dashboardChargeProTypes from 'js/constants/chargeDashboardPro-types';
import axios from 'axios';
import getToken from 'helpers/auth';
import Swal from 'sweetalert2';

const getConfig = () => {
  return {
    headers: { Authorization: `Bearer ${getToken()}` },
  };
};

export const getChargeDashboard10MinutalPro = (id, startDate, endDate) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/data10Minutal',
        {
          charge_id: id,
          start_date: startDate,
          end_date: endDate,
        },
        getConfig()
      )
      .then((response) => {
        if (response.data.success) {
          dispatch(getChargeDashboard10MinutalProSuccess(response.data.data));
        } else {
          dispatch(
            getChargeDashboard10MinutalProFailure(response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(getChargeDashboard10MinutalProFailure(error));
        console.log(error);
      });
  };
};

export const getChargeDashboard10MinutalProSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_SUCCESS,
    payload: data,
  };
};
export const getChargeDashboard10MinutalProFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_FAILURE,
    payload: error,
  };
};

export const getChargeDashboard5MinutalPro = (id, startDate, endDate) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/data5Minutal',
        {
          charge_id: id,
          start_date: startDate,
          end_date: endDate,
        },
        getConfig()
      )
      .then((response) => {
        if (response.data.success) {
          dispatch(getChargeDashboard5MinutalProSuccess(response.data.data));
        } else {
          dispatch(getChargeDashboard5MinutalProFailure(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(getChargeDashboard5MinutalProFailure(error));
        console.log(error);
      });
  };
};

export const getChargeDashboard5MinutalProSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_SUCCESS,
    payload: data,
  };
};

export const getChargeDashboard5MinutalProFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_FAILURE,
    payload: error,
  };
};

export const getChargeDashboardHarmonicPro = (id, startDate, endDate) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/harmonics',
        {
          charge_id: id,
          start_date: startDate,
          end_date: endDate,
        },
        getConfig()
      )
      .then((response) => {
        if (response.data.success) {
          dispatch(getChargeDashboardHarmonicProSuccess(response.data.data));
        } else {
          dispatch(getChargeDashboardHarmonicProFailure(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(getChargeDashboardHarmonicProFailure(error));
        console.error(error);
      });
  };
};

export const getChargeDashboardHarmonicProSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_HARMONIC_PRO_SUCCESS,
    payload: data,
  };
};

export const getChargeDashboardHarmonicProFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_HARMONIC_PRO_FAILURE,
    payload: error,
  };
};

export const getChargeProReport = (data, setBlocking) => {
  function getFileName(disposition) {
    let filename = null;
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    return filename;
  }

  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/report',
        {
          charge_id: data.id,
          start_date: data.startDate,
          end_date: data.endDate,
          lines: data.lines,
          harmonics: data.harmonics,
          types: data.types,
        },
        {
          headers: { Authorization: 'Bearer ' + getToken() },
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        const typeApp =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        const fileName =
          getFileName(response.headers['content-disposition']) ||
          'reporte.xlsx';
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setBlocking(false);
      })
      .catch((error) => {
        dispatch(getChargeProReportFailure(error));
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.message || 'No se pudo descargar el archivo.',
        });
        console.error(error);
        setBlocking(false);
      });
  };
};

export const getChargeProReportSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_PRO_REPORT_SUCCESS,
    payload: data,
  };
};

export const getChargeProReportFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_PRO_REPORT_FAILURE,
    payload: error,
  };
};

export const getChargeProReportPDF = (data, setBlocking) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/pdf_report',
        {
          charge_id: data.id,
          start_date: data.startDate,
          end_date: data.endDate,
          lines: data.lines,
          harmonics: data.harmonics,
          types: data.types,
          contacts: data.contact,
        },
        {
          headers: { Authorization: 'Bearer ' + getToken() },
          responseType: 'arraybuffer', // importante para binarios
        }
      )
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Reporte Enviado',
          text: 'El Reporte se Enviara a Su Correo Electronico en un Lapso de 5 Minutos',
        });
        setBlocking(false);
      })
      .catch((error) => {
        dispatch(getChargeProReportPDFFailure(error));
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.message || 'No se pudo descargar el archivo.',
        });
        console.error(error);
        setBlocking(false);
      });
  };
};

export const getChargeProReportPDFSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_PRO_REPORT_PDF_SUCCESS,
    payload: data,
  };
};

export const getChargeProReportPDFFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_PRO_REPORT_PDF_FAILURE,
    payload: error,
  };
};

export const getChargeDashboardProFlickerPlt = (id, startDate, endDate) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/data2hr',
        {
          charge_id: id,
          start_date: startDate,
          end_date: endDate,
        },
        getConfig()
      )
      .then((response) => {
        if (response.data.success) {
          dispatch(getChargeDashboardProFlickerPltSuccess(response.data.data));
        } else {
          dispatch(
            getChargeDashboardProFlickerPltFailure(response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(getChargeDashboardProFlickerPltFailure(error));
        console.error(error);
      });
  };
};

export const getChargeDashboardProFlickerPltSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_SUCCESS,
    payload: data,
  };
};

export const getChargeDashboardProFlickerPltFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_FAILURE,
    payload: error,
  };
};

export const getChargeDashboardNotification = (id, startDate, endDate) => {
  return async (dispatch) => {
    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/events',
        {
          charge_id: id,
          start_date: startDate,
          end_date: endDate,
        },
        getConfig()
      )
      .then((response) => {
        if (response.data.success) {
          dispatch(getChargeDashboardNotificationSuccess(response.data.data));
        } else {
          dispatch(
            getChargeDashboardNotificationFailure(response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(getChargeDashboardNotificationFailure(error));
        console.error(error);
      });
  };
};

export const getChargeDashboardNotificationSuccess = (data) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_NOTIFICATION_SUCCESS,
    payload: data,
  };
};

export const getChargeDashboardNotificationFailure = (error) => {
  return {
    type: dashboardChargeProTypes.GET_CHARGE_DASHBOARD_NOTIFICATION_FAILURE,
    payload: error,
  };
};
